import type { SVGProps } from "react";
// generated from Label.svg — do not edit manually
// prettier-ignore
export default function Label(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 3 V 12 L 13 22 L 22 13 L 12 3 H 3 Z" stroke="currentColor" strokeWidth="1.5"/><path d="M 10 9 C 10 9.552 9.552 10 9 10 C 8.448 10 8 9.552 8 9 C 8 8.448 8.448 8 9 8 C 9.552 8 10 8.448 10 9 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
